<template>
  <div>
    <v-row dense>
      <v-col
        v-for="(data, index) in dados"
        :key="index"
        cols="6"
        sm="4"
        md="3"
        lg="2"
      >
        <v-card
          outlined
          class="tariff-card"
        >
          <div
            class="tariff-accent"
            :style="{ background: resolveServiceColor(data.title) }"
          />
          <v-card-text class="pa-3">
            <div class="d-flex align-center mb-2">
              <v-avatar
                size="28"
                :color="resolveServiceAvatarColor(data.title)"
                rounded
                class="elevation-1"
              >
                <v-icon
                  dark
                  color="white"
                  size="16"
                >
                  {{ resolveServiceIcon(data.title) }}
                </v-icon>
              </v-avatar>
              <p
                class="text-xs text--secondary mb-0 ms-2"
                style="line-height: 1.2; font-size: 0.7rem !important;"
              >
                {{ data.title }}
              </p>
            </div>
            <h3
              class="tariff-value font-weight-bold"
              :style="{ color: resolveServiceColor(data.title) }"
            >
              R$ {{ $money(data.total, 4) }}
            </h3>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import {
  mdiCurrencyUsd,
  mdiMessageTextOutline,
  mdiPhonePlusOutline,
  mdiCheckAll,
} from '@mdi/js'

export default {
  props: {
    dados: {
      type: Array,
      default: () => [],
    },
  },
  setup() {
    const resolveServiceColor = name => {
      if (!name) return '#0091EA'
      const n = name.toLowerCase()
      if (n.includes('sms')) return '#06F11A'
      if (n.includes('voz') || n.includes('voice')) return '#FFB400'
      if (n.includes('higien') || n.includes('sanit')) return '#00C853'

      return '#0091EA'
    }

    const resolveServiceAvatarColor = name => {
      if (!name) return 'info'
      const n = name.toLowerCase()
      if (n.includes('sms')) return 'primary'
      if (n.includes('voz') || n.includes('voice')) return 'warning'
      if (n.includes('higien') || n.includes('sanit')) return 'success'

      return 'info'
    }

    const resolveServiceIcon = name => {
      if (!name) return mdiCurrencyUsd
      const n = name.toLowerCase()
      if (n.includes('sms')) return mdiMessageTextOutline
      if (n.includes('voz') || n.includes('voice')) return mdiPhonePlusOutline
      if (n.includes('higien') || n.includes('sanit')) return mdiCheckAll

      return mdiCurrencyUsd
    }

    return {
      resolveServiceColor,
      resolveServiceAvatarColor,
      resolveServiceIcon,
    }
  },
}
</script>

<style lang="scss" scoped>
.tariff-card {
  position: relative;
  overflow: hidden;
  transition: box-shadow 0.2s ease;

  &:hover {
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2) !important;
  }
}

.tariff-accent {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  border-radius: 14px 14px 0 0;
}

.tariff-value {
  font-size: 0.95rem;
  line-height: 1.2;
}
</style>
